import { notificationGroupData } from '@/components/notifications-list/notifications'

export interface State {
  notifications: notificationGroupData[]
}
export const state = (): State => ({
  notifications: [],
})
